<div id="page-wrapper" class="page-wrapper toggled-sidebar" *mobxAutorun>
    <dashboard-nav [user]="store?.user" [term]="evn?.term" [campus]="store?.user?.campus"
        (onSignOut)="store?.signOut()">
    </dashboard-nav>
    <main-sidebar [appName]="APP_NAME" [menu]="APP_OPTIONS"></main-sidebar>
    <main id="main" class="puc-app">
        <router-outlet></router-outlet>
    </main>
</div>